export { default } from '@/screens/Scan2PayScreen'
